export default __webpack_public_path__ + "static/media/Briefcase_News_Business_Terms_and_Conditions_04_March_2019.e1fc7588.pdf";